export const AUTH = {
  JOIN: "/auth/join",
  LOGIN: "/auth/login",
  LOGOUT: "/auth/logout",
  REFRESH_TOKEN: "/auth/refresh-token",
  RESET_PASSWORD: "/auth/reset-password",
  VALIDATE_JOIN_TOKEN: "/auth/validate/join-token",
  VALIDATE_RESET_PASSWORD_TOKEN: "/auth/validate/reset-password-token",
};

export const FORECAST = {
  FORECAST: (powerPlantId: string) => `/forecast/${powerPlantId}`,
};

export const POWER_PLANT = {
  POWER_PLANT: (powerPlantId: string) => `/power-plant/${powerPlantId}`,
  POWER_PLANT_LIVE: (powerPlantId: string) =>
    `/power-plant/${powerPlantId}/live`,
  POWER_PLANT_PERMISSIONS: (powerPlantId: string) =>
    `/power-plant/${powerPlantId}/permissions`,
};

export const RECORDS = {
  RECORDS: (powerPlantId: string) => `/records/${powerPlantId}`,
};

export const NOTIFICATIONS = {
  VAPID_KEY: "/notifications/vapid-key",
  SUBSCRIBE: "/notifications/subscribe",
  USER_PREFERENCES: "/notifications/preferences/user",
  PLANT_PREFERENCES: "/notifications/preferences/plant",
  PLANT_PREFERENCE: (meterId: string) => `/notifications/preferences/plant/${meterId}`,
};

export const USER = {
  USER: "/user",
};

export const PRICES = {
  PRICES: "/prices",
  AVAILABILITY: "/prices/availability",
  FORECAST: "/prices/forecast",
  FORECAST_SCORE: "/prices/forecast/score",
};

export const RELAY = {
  RELAY: (powerPlantId: string) => `/relay/${powerPlantId}`,
  RELAY_CHANNEL: (powerPlantId: string, channelNumber: number) =>
    `/relay/${powerPlantId}/${channelNumber}`,
};

export const INVERTER = {
  INVERTERS: (powerPlantId: string) => `/power-plant/${powerPlantId}/inverters`,
  COMMANDS: (powerPlantId: string, inverterId: string) =>
    `/power-plant/${powerPlantId}/inverters/${inverterId}/commands`,
};

export const TRADEA = {
  EARNINGS: (powerPlantId: string) => `/tradea/${powerPlantId}/earnings`,
  EARNINGS_SUMMARY: (powerPlantId: string) =>
    `/tradea/${powerPlantId}/earnings/summary`,
  CURTAILMENT: (powerPlantId: string) => `/tradea/${powerPlantId}/curtailment`,
  STRATEGY: (powerPlantId: string) => `/tradea/${powerPlantId}/strategy`,
};
